import React, { useCallback, useContext, useEffect } from 'react';
import { MergeDuplicateMetricsContext } from './MergeDuplicateMetrics';
import MetricUsageLookupContext from '../../../../../contexts/MetricUsageLookupContext';
import Typography from '../../../../../kingpin/atoms/Typography';
import styled from 'styled-components';
import Button from '../../../../../kingpin/atoms/Button';
import usePopup from '../../../../../hooks/usePopup';
import UsagePopup from './UsagePopup';

const MetricContainer = styled.div`
  width: 100%;
  border: 1px solid var(--color-border-secondary);
  cursor: pointer;
  display: flex;
`;

const MetricWrapper = styled.div`
  padding: 10px;
  display: flex;
  justify-content: space-between;
  flex: 1;
`;

const MetricSelected = styled.div`
  border-left: 3px solid var(--color-info-v2);
  display: block;
  flex: 0;
`;

const DuplicateMetric = ({ metric }: { metric: Metrics.NormalMetric }) => {
  const { primaryMetric, setPrimaryMetric, setHasDatasets } = useContext(
    MergeDuplicateMetricsContext,
  );
  const { metricLookup } = useContext(MetricUsageLookupContext);
  const { isOpen, open, close } = usePopup();

  useEffect(() => {
    if (metricLookup[metric.id]?.performanceConfigurations?.length) {
      setHasDatasets(true);
    }
  }, [metric.id, metricLookup, setHasDatasets]);

  const primaryMetricSelected = useCallback(() => {
    setPrimaryMetric(metric);
  }, [metric, setPrimaryMetric]);

  return (
    <>
      <MetricContainer>
        {primaryMetric?.id === metric.id && <MetricSelected />}
        <MetricWrapper onClick={primaryMetricSelected}>
          <span style={{ padding: 5, flex: 1 }}>
            <Typography.Body type={'Body 13'}>{metric.name}</Typography.Body>
          </span>
          <Button
            label={`Show Usages (${metricLookup[metric.id]?.usageCount || 0})`}
            size={'Small'}
            icon={'info'}
            testId={`show-usages-${metric.id}`}
            onClick={open}
            type={'Secondary'}
          />
        </MetricWrapper>
      </MetricContainer>
      <UsagePopup isOpen={isOpen} close={close} metric={metric} />
    </>
  );
};

export default DuplicateMetric;
